import { DateTime } from 'luxon';
import { useCallback } from 'react';
import { getMonthsBefore } from 'js/utils/date.util';

import * as actions from '../store/actions';
import { get3MonthsBefore } from '../helpers';
import { useDynamicReducerDispatch } from '../store';
import {
    ANOTHER_PERIOD_VALUE,
    LAST_MONTH_VALUE,
    LAST_THREE_MONTHS_VALUE,
    LAST_SIX_MONTHS_VALUE,
    ONE_MONTH_VALUE
} from '../constants';

export const useOnPeriodFilterChange = () => {
    const dispatch = useDynamicReducerDispatch();

    return useCallback((event) => {
        const period = event.target.value;
        const days = Number(period);

        switch (days) {
            case ANOTHER_PERIOD_VALUE: {
                dispatch(actions.setPeriod({
                    period: days
                }));

                break;
            }

            case LAST_MONTH_VALUE:
                dispatch(actions.setPeriod({
                    period: days,
                    endDate: new Date(),
                    startDate: getMonthsBefore(ONE_MONTH_VALUE)
                }));

                break;

            case LAST_THREE_MONTHS_VALUE:
                dispatch(actions.setPeriod({
                    period: days,
                    endDate: new Date(),
                    startDate: get3MonthsBefore()
                }));

                break;

            case LAST_SIX_MONTHS_VALUE: {
                dispatch(actions.setPeriod({
                    period: days,
                    startDate: get3MonthsBefore(),
                    endDate: new Date()
                }));

                break;
            }

            default: {
                const date = DateTime.local()
                    .minus({ days })
                    .toJSDate();

                dispatch(actions.setPeriod({
                    period: days,
                    startDate: date,
                    endDate: new Date()
                }));

                break;
            }
        }
    }, [dispatch]);
};
